

// // // // // import { useState, useEffect } from "react";
// // // // // import {
// // // // //   TableContainer,
// // // // //   Table,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   TableCell,
// // // // //   TableBody,
// // // // //   Paper,
// // // // //   Card,
// // // // //   CardContent,
// // // // //   Box,
// // // // //   Typography,
// // // // //   Button,
// // // // //   Alert,
// // // // //   Snackbar,
// // // // // } from "@mui/material";

// // // // // import InputLabel from "@mui/material/InputLabel";
// // // // // import MenuItem from "@mui/material/MenuItem";
// // // // // import FormControl from "@mui/material/FormControl";
// // // // // import Select from "@mui/material/Select";
// // // // // import TextField from "@mui/material/TextField";
// // // // // import { useStateContext } from "../context/ContextProvider";

// // // // // import axiosClient from "../axiosClient";
// // // // // import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// // // // // import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// // // // // import UserEditModal from "../components/UserEditModal";
// // // // // import ClientComment from "../components/ClientComment";

// // // // // import { AddComment } from "@mui/icons-material";
// // // // // import { useTheme } from "@mui/material/styles";
// // // // // import { useTranslation } from "react-i18next";   // <-- enable translations

// // // // // const genderChoices = [
// // // // //   { label: "Male", value: "M" },
// // // // //   { label: "Female", value: "F" },
// // // // // ];

// // // // // const roleChoices = [
// // // // //   { label: "Admin", value: "ADMIN" },
// // // // //   { label: "Client", value: "CLIENT" },
// // // // //   { label: "Staff", value: "STAFF" },
// // // // // ];

// // // // // const EditDeleteUsers = () => {
// // // // //   const theme = useTheme();
// // // // //   const { t } = useTranslation();                // <-- hook
// // // // //   const [users, setUsers] = useState([]);
// // // // //   const [openModal, setOpenModal] = useState(false);
// // // // //   const [openClientModal, setOpenClientModal] = useState(false);
// // // // //   const { user } = useStateContext();
// // // // //   const [id, setId] = useState();

// // // // //   const [gender, setGender] = useState("");
// // // // //   const [role, setRole] = useState("");
// // // // //   const [search, setSearch] = useState("");

// // // // //   const handleModalOpen = (id) => {
// // // // //     setId(id);
// // // // //     setOpenModal(true);
// // // // //   };

// // // // //   const handleModalClose = () => {
// // // // //     setOpenModal(false);
// // // // //   };

// // // // //   const handleClientModalOpen = (id) => {
// // // // //     setId(id);
// // // // //     setOpenClientModal(true);
// // // // //   };

// // // // //   const handleClientModalClose = () => {
// // // // //     setOpenClientModal(false);
// // // // //   };

// // // // //   const getUsers = () => {
// // // // //     const params = {};

// // // // //     if (role) params["role"] = role;
// // // // //     if (gender) params["gender"] = gender;
// // // // //     if (search) params["search"] = search;

// // // // //     axiosClient
// // // // //       .get("api/print_all_users/", { params })
// // // // //       .then((data) => {
// // // // //         setUsers(data.data.custom_users);
// // // // //       })
// // // // //       .catch((err) => {
// // // // //         console.log(err);
// // // // //       });
// // // // //   };

// // // // //   const handleDelete = (userId) => {
// // // // //     axiosClient
// // // // //       .delete(`api/user/${userId}/`)
// // // // //       .then(() => {
// // // // //         getUsers();
// // // // //       })
// // // // //       .catch((error) => {
// // // // //         console.error("Error deleting user:", error);
// // // // //       });
// // // // //   };

// // // // //   useEffect(() => {
// // // // //     getUsers();
// // // // //     // eslint-disable-next-line
// // // // //   }, [gender, role, search]);

// // // // //   const [snackbar, setSnackbar] = useState({
// // // // //     open: false,
// // // // //     message: "",
// // // // //     severity: "",
// // // // //   });

// // // // //   const handleSend = async (email) => {
// // // // //     try {
// // // // //       const response = await axiosClient.post("/auth/forgot_password/", {
// // // // //         email,
// // // // //       });
// // // // //       console.log(response.data);
// // // // //       setSnackbar({
// // // // //         open: true,
// // // // //         message: t("Password reset email sent successfully!"),
// // // // //         severity: "success",
// // // // //       });
// // // // //     } catch (error) {
// // // // //       console.error("Error sending email:", error.response?.data);
// // // // //       setSnackbar({
// // // // //         open: true,
// // // // //         message: t("Failed to send password reset email."),
// // // // //         severity: "error",
// // // // //       });
// // // // //     }
// // // // //   };

// // // // //   const handleClose = () => {
// // // // //     setSnackbar({ open: false, message: "", severity: "" });
// // // // //   };

// // // // //   return (
// // // // //     <>
// // // // //       <Snackbar
// // // // //         open={snackbar.open}
// // // // //         autoHideDuration={4000}
// // // // //         onClose={handleClose}
// // // // //         anchorOrigin={{ vertical: "top", horizontal: "right" }}
// // // // //       >
// // // // //         <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: "100%" }}>
// // // // //           {snackbar.message}
// // // // //         </Alert>
// // // // //       </Snackbar>

// // // // //       <Box
// // // // //         display="flex"
// // // // //         justifyContent="center"
// // // // //         alignItems="center"
// // // // //         marginTop="16"
// // // // //       >
// // // // //         <Card elevation={16}>
// // // // //           <CardContent>
// // // // //             {/* Search & Filter block */}
// // // // //             <Box
// // // // //               sx={{
// // // // //                 display: "flex",
// // // // //                 justifyContent: "space-between",
// // // // //                 mb: 5,
// // // // //                 gap: 2,
// // // // //                 width: "100%",
// // // // //               }}
// // // // //             >
// // // // //               <Box sx={{ width: "100%" }}>
// // // // //                 <Typography
// // // // //                   variant="body1"
// // // // //                   sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
// // // // //                 >
// // // // //                   {t("Search By")}
// // // // //                 </Typography>
// // // // //                 <TextField
// // // // //                   fullWidth
// // // // //                   id="search"
// // // // //                   label={t("Search")}
// // // // //                   variant="outlined"
// // // // //                   value={search}
// // // // //                   onChange={(e) => setSearch(e.target.value)}
// // // // //                 />
// // // // //               </Box>

// // // // //               <Box sx={{ width: "100%" }}>
// // // // //                 <Typography
// // // // //                   variant="body1"
// // // // //                   sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
// // // // //                 >
// // // // //                   {t("Filter By")}
// // // // //                 </Typography>
// // // // //                 <Box sx={{ display: "flex", gap: 2 }}>
// // // // //                   {/* Role filter */}
// // // // //                   <FormControl fullWidth>
// // // // //                     <InputLabel id="role-select-label">{t("Role")}</InputLabel>
// // // // //                     <Select
// // // // //                       labelId="role-select-label"
// // // // //                       id="role-select"
// // // // //                       value={role}
// // // // //                       label={t("Role")}
// // // // //                       onChange={(e) => setRole(e.target.value)}
// // // // //                       sx={{ textAlign: "left" }}
// // // // //                     >
// // // // //                       <MenuItem value="">{t("Default")}</MenuItem>
// // // // //                       {roleChoices.map((roleChoice, idx) => (
// // // // //                         <MenuItem key={idx} value={roleChoice.value}>
// // // // //                           {roleChoice.value === "ADMIN"
// // // // //                             ? t("Secretary")
// // // // //                             : roleChoice.value === "STAFF"
// // // // //                             ? t("Doctor")
// // // // //                             : t("Patient")}
// // // // //                         </MenuItem>
// // // // //                       ))}
// // // // //                     </Select>
// // // // //                   </FormControl>

// // // // //                   {/* Gender filter */}
// // // // //                   <FormControl fullWidth>
// // // // //                     <InputLabel id="gender-select-label">
// // // // //                       {t("Gender")}
// // // // //                     </InputLabel>
// // // // //                     <Select
// // // // //                       labelId="gender-select-label"
// // // // //                       id="gender-select"
// // // // //                       value={gender}
// // // // //                       label={t("Gender")}
// // // // //                       onChange={(e) => setGender(e.target.value)}
// // // // //                       sx={{ textAlign: "left" }}
// // // // //                     >
// // // // //                       <MenuItem value="">{t("Default")}</MenuItem>
// // // // //                       {genderChoices.map((genderChoice, idx) => (
// // // // //                         <MenuItem key={idx} value={genderChoice.value}>
// // // // //                           {t(genderChoice.label)}
// // // // //                         </MenuItem>
// // // // //                       ))}
// // // // //                     </Select>
// // // // //                   </FormControl>
// // // // //                 </Box>
// // // // //               </Box>
// // // // //             </Box>

// // // // //             {/* Table */}
// // // // //             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // // // //               <Table>
// // // // //                 <TableHead>
// // // // //                   <TableRow>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Name")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Surname")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Date of Birth")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Gender")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Email")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Hardcopy Consent")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Username")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Phone Number")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Role")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Assigned Doctor")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("User ID")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell sx={{ textAlign: "center" }}>
// // // // //                       <Typography variant="h7" sx={{ fontWeight: "bold" }}>
// // // // //                         {t("Action")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Forgot Password")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       <Typography
// // // // //                         variant="h7"
// // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // //                       >
// // // // //                         {t("Comment")}
// // // // //                       </Typography>
// // // // //                     </TableCell>
// // // // //                   </TableRow>
// // // // //                 </TableHead>

// // // // //                 <TableBody>
// // // // //                   {users.map((row, index) => (
// // // // //                     <TableRow key={index}>
// // // // //                       <TableCell>{row.first_name}</TableCell>
// // // // //                       <TableCell>{row.last_name}</TableCell>
// // // // //                       <TableCell>{row.date_birth}</TableCell>
// // // // //                       <TableCell sx={{ whiteSpace: "nowrap" }}>
// // // // //                         {row.gender === "M"
// // // // //                           ? t("Male")
// // // // //                           : row.gender === "F"
// // // // //                           ? t("Female")
// // // // //                           : t("Non-declared")}
// // // // //                       </TableCell>
// // // // //                       <TableCell>{row.email}</TableCell>
// // // // //                       <TableCell>
// // // // //                         {row.hardcopy_consent ? t("Yes") : t("No")}
// // // // //                       </TableCell>
// // // // //                       <TableCell>{row.username}</TableCell>
// // // // //                       <TableCell>{row.phone_number}</TableCell>
// // // // //                       <TableCell>
// // // // //                         {row.user_role === "ADMIN"
// // // // //                           ? t("Secretary")
// // // // //                           : row.user_role === "STAFF"
// // // // //                           ? t("Doctor")
// // // // //                           : row.user_role === "CLIENT"
// // // // //                           ? t("Patient")
// // // // //                           : t("Non-declared")}
// // // // //                       </TableCell>
// // // // //                       <TableCell>{row?.assigned_staff?.name}</TableCell>
// // // // //                       <TableCell>{row.id}</TableCell>

// // // // //                       <TableCell sx={{ textAlign: "center" }}>
// // // // //                         <Box
// // // // //                           sx={{ display: "flex", alignItems: "center", gap: 1 }}
// // // // //                         >
// // // // //                           <BorderColorOutlinedIcon
// // // // //                             onClick={() => handleModalOpen(row?.id)}
// // // // //                             sx={{
// // // // //                               cursor: "pointer",
// // // // //                               color:
// // // // //                                 theme.palette.mode === "dark" ? "orange" : "blue",
// // // // //                             }}
// // // // //                           />
// // // // //                           <Box>.</Box>
// // // // //                           <DeleteOutlineOutlinedIcon
// // // // //                             onClick={() => handleDelete(row?.id)}
// // // // //                             sx={{ cursor: "pointer", color: "red" }}
// // // // //                           />
// // // // //                         </Box>
// // // // //                       </TableCell>

// // // // //                       <TableCell>
// // // // //                         <Button
// // // // //                           disabled={
// // // // //                             user.user_role === "STAFF" &&
// // // // //                             !(
// // // // //                               row.user_role === "ADMIN" ||
// // // // //                               row.assigned_staff?.id === user.id
// // // // //                             )
// // // // //                           }
// // // // //                           variant="contained"
// // // // //                           onClick={() => handleSend(row.email)}
// // // // //                         >
// // // // //                           {t("Send")}
// // // // //                         </Button>
// // // // //                       </TableCell>

// // // // //                       <TableCell>
// // // // //                         <Box>
// // // // //                           <AddComment
// // // // //                             sx={{
// // // // //                               cursor: "pointer",
// // // // //                               color:
// // // // //                                 theme.palette.mode === "dark" ? "orange" : "blue",
// // // // //                             }}
// // // // //                             onClick={() => handleClientModalOpen(row.id)}
// // // // //                           />
// // // // //                         </Box>
// // // // //                       </TableCell>
// // // // //                     </TableRow>
// // // // //                   ))}
// // // // //                 </TableBody>
// // // // //               </Table>
// // // // //             </TableContainer>
// // // // //           </CardContent>
// // // // //         </Card>
// // // // //       </Box>

// // // // //       <UserEditModal
// // // // //         open={openModal}
// // // // //         handleClose={handleModalClose}
// // // // //         id={id}
// // // // //         getUsers={getUsers}
// // // // //       />

// // // // //       <ClientComment
// // // // //         open={openClientModal}
// // // // //         handleClose={handleClientModalClose}
// // // // //         id={id}
// // // // //         getUsers={getUsers}
// // // // //       />
// // // // //     </>
// // // // //   );
// // // // // };

// // // // // export default EditDeleteUsers;

// // // // import { useState, useEffect } from "react";
// // // // import {
// // // //   TableContainer,
// // // //   Table,
// // // //   TableHead,
// // // //   TableRow,
// // // //   TableCell,
// // // //   TableBody,
// // // //   Paper,
// // // //   Card,
// // // //   CardContent,
// // // //   Box,
// // // //   Typography,
// // // //   Button,
// // // //   Alert,
// // // //   Snackbar,
// // // // } from "@mui/material";

// // // // import InputLabel from "@mui/material/InputLabel";
// // // // import MenuItem from "@mui/material/MenuItem";
// // // // import FormControl from "@mui/material/FormControl";
// // // // import Select from "@mui/material/Select";
// // // // import TextField from "@mui/material/TextField";
// // // // import { useStateContext } from "../context/ContextProvider";

// // // // import axiosClient from "../axiosClient";
// // // // import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// // // // import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// // // // import UserEditModal from "../components/UserEditModal";
// // // // import ClientComment from "../components/ClientComment";

// // // // import { AddComment } from "@mui/icons-material";
// // // // import { useTheme } from "@mui/material/styles";
// // // // import { useTranslation } from "react-i18next";

// // // // const genderChoices = [
// // // //   { label: "Male", value: "M" },
// // // //   { label: "Female", value: "F" },
// // // // ];

// // // // const roleChoices = [
// // // //   { label: "Admin", value: "ADMIN" },
// // // //   { label: "Client", value: "CLIENT" },
// // // //   { label: "Staff", value: "STAFF" },
// // // // ];

// // // // const EditDeleteUsers = () => {
// // // //   const theme = useTheme();
// // // //   const { t } = useTranslation();
// // // //   const [users, setUsers] = useState([]);
// // // //   const [openModal, setOpenModal] = useState(false);
// // // //   const [openClientModal, setOpenClientModal] = useState(false);
// // // //   const { user } = useStateContext();
// // // //   const [id, setId] = useState();

// // // //   const [gender, setGender] = useState("");
// // // //   const [role, setRole] = useState("");
// // // //   const [search, setSearch] = useState("");

// // // //   const handleModalOpen = (id) => {
// // // //     setId(id);
// // // //     setOpenModal(true);
// // // //   };

// // // //   const handleModalClose = () => {
// // // //     setOpenModal(false);
// // // //   };

// // // //   const handleClientModalOpen = (id) => {
// // // //     setId(id);
// // // //     setOpenClientModal(true);
// // // //   };

// // // //   const handleClientModalClose = () => {
// // // //     setOpenClientModal(false);
// // // //   };

// // // //   const getUsers = () => {
// // // //     const params = {};

// // // //     if (role) params["role"] = role;
// // // //     if (gender) params["gender"] = gender;
// // // //     if (search) params["search"] = search;

// // // //     axiosClient
// // // //       .get("api/print_all_users/", { params })
// // // //       .then((data) => {
// // // //         setUsers(data.data.custom_users);
// // // //       })
// // // //       .catch((err) => {
// // // //         console.log(err);
// // // //       });
// // // //   };

// // // //   const handleDelete = (userId) => {
// // // //     axiosClient
// // // //       .delete(`api/user/${userId}/`)
// // // //       .then(() => {
// // // //         getUsers();
// // // //       })
// // // //       .catch((error) => {
// // // //         console.error("Error deleting user:", error);
// // // //       });
// // // //   };

// // // //   useEffect(() => {
// // // //     getUsers();
// // // //     // eslint-disable-next-line
// // // //   }, [gender, role, search]);

// // // //   const [snackbar, setSnackbar] = useState({
// // // //     open: false,
// // // //     message: "",
// // // //     severity: "",
// // // //   });

// // // //   const handleSend = async (email) => {
// // // //     try {
// // // //       const response = await axiosClient.post("/auth/forgot_password/", {
// // // //         email,
// // // //       });
// // // //       console.log(response.data);
// // // //       setSnackbar({
// // // //         open: true,
// // // //         message: t("Password reset email sent successfully!"),
// // // //         severity: "success",
// // // //       });
// // // //     } catch (error) {
// // // //       console.error("Error sending email:", error.response?.data);
// // // //       setSnackbar({
// // // //         open: true,
// // // //         message: t("Failed to send password reset email."),
// // // //         severity: "error",
// // // //       });
// // // //     }
// // // //   };

// // // //   const handleClose = () => {
// // // //     setSnackbar({ open: false, message: "", severity: "" });
// // // //   };

// // // //   return (
// // // //     <>
// // // //       <Snackbar
// // // //         open={snackbar.open}
// // // //         autoHideDuration={4000}
// // // //         onClose={handleClose}
// // // //         anchorOrigin={{ vertical: "top", horizontal: "right" }}
// // // //       >
// // // //         <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: "100%" }}>
// // // //           {snackbar.message}
// // // //         </Alert>
// // // //       </Snackbar>

// // // //       <Box
// // // //         display="flex"
// // // //         justifyContent="center"
// // // //         alignItems="center"
// // // //         marginTop="16"
// // // //       >
// // // //         <Card elevation={16}>
// // // //           <CardContent>
// // // //             {/* Search & Filter block */}
// // // //             <Box
// // // //               sx={{
// // // //                 display: "flex",
// // // //                 justifyContent: "space-between",
// // // //                 mb: 5,
// // // //                 gap: 2,
// // // //                 width: "100%",
// // // //               }}
// // // //             >
// // // //               {/* Search */}
// // // //               <Box sx={{ width: "100%" }}>
// // // //                 <Typography
// // // //                   variant="body1"
// // // //                   sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
// // // //                 >
// // // //                   {t("Search By")}
// // // //                 </Typography>
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   id="search"
// // // //                   label={t("Search")}
// // // //                   variant="outlined"
// // // //                   value={search}
// // // //                   onChange={(e) => setSearch(e.target.value)}
// // // //                 />
// // // //               </Box>

// // // //               {/* Filters */}
// // // //               <Box sx={{ width: "100%" }}>
// // // //                 <Typography
// // // //                   variant="body1"
// // // //                   sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
// // // //                 >
// // // //                   {t("Filter By")}
// // // //                 </Typography>
// // // //                 <Box sx={{ display: "flex", gap: 2 }}>
// // // //                   {/* Role filter */}
// // // //                   <FormControl fullWidth>
// // // //                     <InputLabel id="role-select-label">{t("Role")}</InputLabel>
// // // //                     <Select
// // // //                       labelId="role-select-label"
// // // //                       id="role-select"
// // // //                       value={role}
// // // //                       label={t("Role")}
// // // //                       onChange={(e) => setRole(e.target.value)}
// // // //                       sx={{ textAlign: "left" }}
// // // //                     >
// // // //                       <MenuItem value="">{t("Default")}</MenuItem>
// // // //                       {roleChoices.map((roleChoice, idx) => (
// // // //                         <MenuItem key={idx} value={roleChoice.value}>
// // // //                           {roleChoice.value === "ADMIN"
// // // //                             ? t("Secretary")
// // // //                             : roleChoice.value === "STAFF"
// // // //                             ? t("Doctor")
// // // //                             : t("Patient")}
// // // //                         </MenuItem>
// // // //                       ))}
// // // //                     </Select>
// // // //                   </FormControl>

// // // //                   {/* Gender filter */}
// // // //                   <FormControl fullWidth>
// // // //                     <InputLabel id="gender-select-label">
// // // //                       {t("Gender")}
// // // //                     </InputLabel>
// // // //                     <Select
// // // //                       labelId="gender-select-label"
// // // //                       id="gender-select"
// // // //                       value={gender}
// // // //                       label={t("Gender")}
// // // //                       onChange={(e) => setGender(e.target.value)}
// // // //                       sx={{ textAlign: "left" }}
// // // //                     >
// // // //                       <MenuItem value="">{t("Default")}</MenuItem>
// // // //                       {genderChoices.map((genderChoice, idx) => (
// // // //                         <MenuItem key={idx} value={genderChoice.value}>
// // // //                           {t(genderChoice.label)}
// // // //                         </MenuItem>
// // // //                       ))}
// // // //                     </Select>
// // // //                   </FormControl>
// // // //                 </Box>
// // // //               </Box>
// // // //             </Box>

// // // //             {/* Table */}
// // // //             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // // //               <Table>
// // // //                 <TableHead>
// // // //                   <TableRow>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Name")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Surname")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Date of Birth")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Gender")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Email")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Hardcopy Consent")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Username")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Phone Number")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Role")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Assigned Doctor")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("User ID")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell sx={{ textAlign: "center" }}>
// // // //                       <Typography variant="h7" sx={{ fontWeight: "bold" }}>
// // // //                         {t("Action")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Forgot Password")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       <Typography
// // // //                         variant="h7"
// // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // //                       >
// // // //                         {t("Comment")}
// // // //                       </Typography>
// // // //                     </TableCell>
// // // //                   </TableRow>
// // // //                 </TableHead>

// // // //                 <TableBody>
// // // //                   {users.map((row, index) => (
// // // //                     <TableRow key={index}>
// // // //                       <TableCell>{row.first_name}</TableCell>
// // // //                       <TableCell>{row.last_name}</TableCell>
// // // //                       <TableCell>{row.date_birth}</TableCell>
// // // //                       <TableCell sx={{ whiteSpace: "nowrap" }}>
// // // //                         {row.gender === "M"
// // // //                           ? t("Male")
// // // //                           : row.gender === "F"
// // // //                           ? t("Female")
// // // //                           : t("Non-declared")}
// // // //                       </TableCell>
// // // //                       <TableCell>{row.email}</TableCell>
// // // //                       <TableCell>
// // // //                         {row.hardcopy_consent ? t("Yes") : t("No")}
// // // //                       </TableCell>
// // // //                       <TableCell>{row.username}</TableCell>
// // // //                       <TableCell>{row.phone_number}</TableCell>
// // // //                       <TableCell>
// // // //                         {row.user_role === "ADMIN"
// // // //                           ? t("Secretary")
// // // //                           : row.user_role === "STAFF"
// // // //                           ? t("Doctor")
// // // //                           : row.user_role === "CLIENT"
// // // //                           ? t("Patient")
// // // //                           : t("Non-declared")}
// // // //                       </TableCell>
// // // //                       <TableCell>{row?.assigned_staff?.name}</TableCell>
// // // //                       <TableCell>{row.id}</TableCell>

// // // //                       <TableCell sx={{ textAlign: "center" }}>
// // // //                         <Box
// // // //                           sx={{ display: "flex", alignItems: "center", gap: 1 }}
// // // //                         >
// // // //                           <BorderColorOutlinedIcon
// // // //                             onClick={() => handleModalOpen(row?.id)}
// // // //                             sx={{
// // // //                               cursor: "pointer",
// // // //                               color:
// // // //                                 theme.palette.mode === "dark"
// // // //                                   ? "orange"
// // // //                                   : "blue",
// // // //                             }}
// // // //                           />
// // // //                           <Box>.</Box>
// // // //                           <DeleteOutlineOutlinedIcon
// // // //                             onClick={() => handleDelete(row?.id)}
// // // //                             sx={{ cursor: "pointer", color: "red" }}
// // // //                           />
// // // //                         </Box>
// // // //                       </TableCell>

// // // //                       <TableCell>
// // // //                         <Button
// // // //                           disabled={
// // // //                             user.user_role === "STAFF" &&
// // // //                             !(
// // // //                               row.user_role === "ADMIN" ||
// // // //                               row.assigned_staff?.id === user.id
// // // //                             )
// // // //                           }
// // // //                           variant="contained"
// // // //                           onClick={() => handleSend(row.email)}
// // // //                         >
// // // //                           {t("Send")}
// // // //                         </Button>
// // // //                       </TableCell>

// // // //                       <TableCell>
// // // //                         <Box>
// // // //                           <AddComment
// // // //                             sx={{
// // // //                               cursor: "pointer",
// // // //                               color:
// // // //                                 theme.palette.mode === "dark"
// // // //                                   ? "orange"
// // // //                                   : "blue",
// // // //                             }}
// // // //                             onClick={() => handleClientModalOpen(row.id)}
// // // //                           />
// // // //                         </Box>
// // // //                       </TableCell>
// // // //                     </TableRow>
// // // //                   ))}
// // // //                 </TableBody>
// // // //               </Table>
// // // //             </TableContainer>
// // // //           </CardContent>
// // // //         </Card>
// // // //       </Box>

// // // //       <UserEditModal
// // // //         open={openModal}
// // // //         handleClose={handleModalClose}
// // // //         id={id}
// // // //         getUsers={getUsers}
// // // //       />

// // // //       <ClientComment
// // // //         open={openClientModal}
// // // //         handleClose={handleClientModalClose}
// // // //         id={id}
// // // //         getUsers={getUsers}
// // // //       />
// // // //     </>
// // // //   );
// // // // };

// // // // export default EditDeleteUsers;

// // // import { useState, useEffect } from "react";
// // // import {
// // //   TableContainer,
// // //   Table,
// // //   TableHead,
// // //   TableRow,
// // //   TableCell,
// // //   TableBody,
// // //   Paper,
// // //   Card,
// // //   CardContent,
// // //   Box,
// // //   Typography,
// // //   Button,
// // //   Alert,
// // //   Snackbar,
// // // } from "@mui/material";

// // // import InputLabel from "@mui/material/InputLabel";
// // // import MenuItem from "@mui/material/MenuItem";
// // // import FormControl from "@mui/material/FormControl";
// // // import Select from "@mui/material/Select";
// // // import TextField from "@mui/material/TextField";
// // // import { useStateContext } from "../context/ContextProvider";

// // // import axiosClient from "../axiosClient";
// // // import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// // // import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// // // import UserEditModal from "../components/UserEditModal";
// // // import ClientComment from "../components/ClientComment";

// // // import { AddComment } from "@mui/icons-material";
// // // import { useTheme } from "@mui/material/styles";
// // // import { useTranslation } from "react-i18next";

// // // const genderChoices = [
// // //   { label: "Male", value: "M" },
// // //   { label: "Female", value: "F" },
// // // ];

// // // const roleChoices = [
// // //   { label: "Admin", value: "ADMIN" },
// // //   { label: "Client", value: "CLIENT" },
// // //   { label: "Staff", value: "STAFF" },
// // // ];

// // // const normalizeUsers = (data) => {
// // //   if (Array.isArray(data)) return data;
// // //   if (data?.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
// // //   if (data?.results && Array.isArray(data.results)) return data.results;
// // //   return [];
// // // };

// // // const listUsers = async (params) => {
// // //   try {
// // //     const res = await axiosClient.get("api/users/", { params });
// // //     return normalizeUsers(res.data);
// // //   } catch (err) {
// // //     if (err?.response?.status === 404) {
// // //       const res2 = await axiosClient.get("api/print_all_users/", { params });
// // //       return normalizeUsers(res2.data);
// // //     }
// // //     throw err;
// // //   }
// // // };

// // // const deleteUserApi = async (userId) => {
// // //   try {
// // //     return await axiosClient.delete(`api/users/${userId}/`);
// // //   } catch (err) {
// // //     if (err?.response?.status === 404) {
// // //       return await axiosClient.delete(`api/user/${userId}/`);
// // //     }
// // //     throw err;
// // //   }
// // // };

// // // const EditDeleteUsers = () => {
// // //   const theme = useTheme();
// // //   const { t } = useTranslation();
// // //   const [users, setUsers] = useState([]);
// // //   const [openModal, setOpenModal] = useState(false);
// // //   const [openClientModal, setOpenClientModal] = useState(false);
// // //   const { user } = useStateContext();
// // //   const [id, setId] = useState();

// // //   const [gender, setGender] = useState("");
// // //   const [role, setRole] = useState("");
// // //   const [search, setSearch] = useState("");

// // //   const handleModalOpen = (id) => {
// // //     setId(id);
// // //     setOpenModal(true);
// // //   };
// // //   const handleModalClose = () => setOpenModal(false);

// // //   const handleClientModalOpen = (id) => {
// // //     setId(id);
// // //     setOpenClientModal(true);
// // //   };
// // //   const handleClientModalClose = () => setOpenClientModal(false);

// // //   const getUsers = async () => {
// // //     const params = {};
// // //     if (role) params.role = role;
// // //     if (gender) params.gender = gender;
// // //     if (search) params.search = search;

// // //     try {
// // //       const list = await listUsers(params);
// // //       setUsers(list);
// // //     } catch (err) {
// // //       console.log(err);
// // //     }
// // //   };

// // //   const handleDelete = async (userId) => {
// // //     try {
// // //       await deleteUserApi(userId);
// // //       getUsers();
// // //     } catch (error) {
// // //       console.error("Error deleting user:", error);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     getUsers();
// // //     // eslint-disable-next-line
// // //   }, [gender, role, search]);

// // //   const [snackbar, setSnackbar] = useState({
// // //     open: false,
// // //     message: "",
// // //     severity: "success",
// // //   });

// // //   const handleSend = async (email) => {
// // //     try {
// // //       // ✅ correct relative path
// // //       await axiosClient.post("auth/forgot_password/", { email });
// // //       setSnackbar({
// // //         open: true,
// // //         message: t("Password reset email sent successfully!"),
// // //         severity: "success",
// // //       });
// // //     } catch (error) {
// // //       console.error("Error sending email:", error.response?.data);
// // //       setSnackbar({
// // //         open: true,
// // //         message: t("Failed to send password reset email."),
// // //         severity: "error",
// // //       });
// // //     }
// // //   };

// // //   const handleCloseSnackbar = () => setSnackbar({ open: false, message: "", severity: "success" });

// // //   return (
// // //     <>
// // //       <Snackbar
// // //         open={snackbar.open}
// // //         autoHideDuration={4000}
// // //         onClose={handleCloseSnackbar}
// // //         anchorOrigin={{ vertical: "top", horizontal: "right" }}
// // //       >
// // //         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
// // //           {snackbar.message}
// // //         </Alert>
// // //       </Snackbar>

// // //       <Box display="flex" justifyContent="center" alignItems="center" marginTop="16">
// // //         <Card elevation={16} sx={{ width: "95%" }}>
// // //           <CardContent>
// // //             <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
// // //               <Box sx={{ width: "100%" }}>
// // //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // //                   {t("Search By")}
// // //                 </Typography>
// // //                 <TextField fullWidth label={t("Search")} variant="outlined" value={search} onChange={(e) => setSearch(e.target.value)} />
// // //               </Box>

// // //               <Box sx={{ width: "100%" }}>
// // //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // //                   {t("Filter By")}
// // //                 </Typography>

// // //                 <Box sx={{ display: "flex", gap: 2 }}>
// // //                   <FormControl fullWidth>
// // //                     <InputLabel>{t("Role")}</InputLabel>
// // //                     <Select value={role} label={t("Role")} onChange={(e) => setRole(e.target.value)} sx={{ textAlign: "left" }}>
// // //                       <MenuItem value="">{t("Default")}</MenuItem>
// // //                       {roleChoices.map((r, idx) => (
// // //                         <MenuItem key={idx} value={r.value}>
// // //                           {r.value === "ADMIN" ? t("Secretary") : r.value === "STAFF" ? t("Doctor") : t("Patient")}
// // //                         </MenuItem>
// // //                       ))}
// // //                     </Select>
// // //                   </FormControl>

// // //                   <FormControl fullWidth>
// // //                     <InputLabel>{t("Gender")}</InputLabel>
// // //                     <Select value={gender} label={t("Gender")} onChange={(e) => setGender(e.target.value)} sx={{ textAlign: "left" }}>
// // //                       <MenuItem value="">{t("Default")}</MenuItem>
// // //                       {genderChoices.map((g, idx) => (
// // //                         <MenuItem key={idx} value={g.value}>
// // //                           {t(g.label)}
// // //                         </MenuItem>
// // //                       ))}
// // //                     </Select>
// // //                   </FormControl>
// // //                 </Box>
// // //               </Box>
// // //             </Box>

// // //             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // //               <Table stickyHeader>
// // //                 <TableHead>
// // //                   <TableRow>
// // //                     {[
// // //                       "Name",
// // //                       "Surname",
// // //                       "Date of Birth",
// // //                       "Gender",
// // //                       "Email",
// // //                       "Hardcopy Consent",
// // //                       "Username",
// // //                       "Phone Number",
// // //                       "Role",
// // //                       "Assigned Doctor",
// // //                       "User ID",
// // //                       "Action",
// // //                       "Forgot Password",
// // //                       "Comment",
// // //                     ].map((h) => (
// // //                       <TableCell key={h} sx={h === "Action" ? { textAlign: "center" } : {}}>
// // //                         <Typography variant="body2" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
// // //                           {t(h)}
// // //                         </Typography>
// // //                       </TableCell>
// // //                     ))}
// // //                   </TableRow>
// // //                 </TableHead>

// // //                 <TableBody>
// // //                   {users.map((row) => (
// // //                     <TableRow key={row.id}>
// // //                       <TableCell>{row.first_name}</TableCell>
// // //                       <TableCell>{row.last_name}</TableCell>
// // //                       <TableCell>{row.date_birth || ""}</TableCell>
// // //                       <TableCell sx={{ whiteSpace: "nowrap" }}>
// // //                         {row.gender === "M" ? t("Male") : row.gender === "F" ? t("Female") : t("Non-declared")}
// // //                       </TableCell>
// // //                       <TableCell>{row.email}</TableCell>
// // //                       <TableCell>{row.hardcopy_consent ? t("Yes") : t("No")}</TableCell>
// // //                       <TableCell>{row.username}</TableCell>
// // //                       <TableCell>{row.phone_number}</TableCell>
// // //                       <TableCell>
// // //                         {row.user_role === "ADMIN"
// // //                           ? t("Secretary")
// // //                           : row.user_role === "STAFF"
// // //                           ? t("Doctor")
// // //                           : row.user_role === "CLIENT"
// // //                           ? t("Patient")
// // //                           : t("Non-declared")}
// // //                       </TableCell>
// // //                       <TableCell>{row?.assigned_staff?.name || ""}</TableCell>
// // //                       <TableCell>{row.id}</TableCell>

// // //                       <TableCell sx={{ textAlign: "center" }}>
// // //                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
// // //                           <BorderColorOutlinedIcon
// // //                             onClick={() => handleModalOpen(row.id)}
// // //                             sx={{ cursor: "pointer", color: theme.palette.mode === "dark" ? "orange" : "blue" }}
// // //                           />
// // //                           <Box>.</Box>
// // //                           <DeleteOutlineOutlinedIcon onClick={() => handleDelete(row.id)} sx={{ cursor: "pointer", color: "red" }} />
// // //                         </Box>
// // //                       </TableCell>

// // //                       <TableCell>
// // //                         <Button
// // //                           disabled={
// // //                             user?.user_role === "STAFF" &&
// // //                             !(row.user_role === "ADMIN" || row.assigned_staff?.id === user.id)
// // //                           }
// // //                           variant="contained"
// // //                           onClick={() => handleSend(row.email)}
// // //                         >
// // //                           {t("Send")}
// // //                         </Button>
// // //                       </TableCell>

// // //                       <TableCell>
// // //                         <AddComment
// // //                           sx={{ cursor: "pointer", color: theme.palette.mode === "dark" ? "orange" : "blue" }}
// // //                           onClick={() => handleClientModalOpen(row.id)}
// // //                         />
// // //                       </TableCell>
// // //                     </TableRow>
// // //                   ))}
// // //                 </TableBody>
// // //               </Table>
// // //             </TableContainer>
// // //           </CardContent>
// // //         </Card>
// // //       </Box>

// // //       <UserEditModal open={openModal} handleClose={handleModalClose} id={id} getUsers={getUsers} />
// // //       <ClientComment open={openClientModal} handleClose={handleClientModalClose} id={id} getUsers={getUsers} />
// // //     </>
// // //   );
// // // };

// // // export default EditDeleteUsers;


// // // import { useState, useEffect } from "react";
// // // import {
// // //   TableContainer,
// // //   Table,
// // //   TableHead,
// // //   TableRow,
// // //   TableCell,
// // //   TableBody,
// // //   Paper,
// // //   Card,
// // //   CardContent,
// // //   Box,
// // //   Typography,
// // //   Button,
// // //   Alert,
// // //   Snackbar,
// // // } from "@mui/material";

// // // import InputLabel from "@mui/material/InputLabel";
// // // import MenuItem from "@mui/material/MenuItem";
// // // import FormControl from "@mui/material/FormControl";
// // // import Select from "@mui/material/Select";
// // // import TextField from "@mui/material/TextField";
// // // import { useStateContext } from "../context/ContextProvider";

// // // import axiosClient from "../axiosClient";
// // // import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// // // import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// // // import UserEditModal from "../components/UserEditModal";
// // // import ClientComment from "../components/ClientComment";

// // // import { AddComment } from "@mui/icons-material";
// // // import { useTheme } from "@mui/material/styles";
// // // import { useTranslation } from "react-i18next";

// // // const genderChoices = [
// // //   { label: "Male", value: "M" },
// // //   { label: "Female", value: "F" },
// // // ];

// // // // Updated to match Backend USER_ROLE_CHOICES
// // // const roleChoices = [
// // //   { label: "Admin", value: "ADMIN" },
// // //   { label: "Technician", value: "TECHNICIAN" },
// // // ];

// // // const normalizeUsers = (data) => {
// // //   if (Array.isArray(data)) return data;
// // //   if (data?.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
// // //   if (data?.results && Array.isArray(data.results)) return data.results;
// // //   return [];
// // // };

// // // const listUsers = async (params) => {
// // //   try {
// // //     const res = await axiosClient.get("api/users/", { params });
// // //     return normalizeUsers(res.data);
// // //   } catch (err) {
// // //     if (err?.response?.status === 404) {
// // //       const res2 = await axiosClient.get("api/print_all_users/", { params });
// // //       return normalizeUsers(res2.data);
// // //     }
// // //     throw err;
// // //   }
// // // };

// // // const deleteUserApi = async (userId) => {
// // //   try {
// // //     return await axiosClient.delete(`api/users/${userId}/`);
// // //   } catch (err) {
// // //     if (err?.response?.status === 404) {
// // //       return await axiosClient.delete(`api/user/${userId}/`);
// // //     }
// // //     throw err;
// // //   }
// // // };

// // // const EditDeleteUsers = () => {
// // //   const theme = useTheme();
// // //   const { t } = useTranslation();
// // //   const [users, setUsers] = useState([]);
// // //   const [openModal, setOpenModal] = useState(false);
// // //   const [openClientModal, setOpenClientModal] = useState(false);
// // //   const { user } = useStateContext();
// // //   const [id, setId] = useState();

// // //   const [gender, setGender] = useState("");
// // //   const [role, setRole] = useState("");
// // //   const [search, setSearch] = useState("");

// // //   const handleModalOpen = (id) => {
// // //     setId(id);
// // //     setOpenModal(true);
// // //   };
// // //   const handleModalClose = () => setOpenModal(false);

// // //   const handleClientModalOpen = (id) => {
// // //     setId(id);
// // //     setOpenClientModal(true);
// // //   };
// // //   const handleClientModalClose = () => setOpenClientModal(false);

// // //   const getUsers = async () => {
// // //     const params = {};
// // //     if (role) params.role = role;
// // //     if (gender) params.gender = gender;
// // //     if (search) params.search = search;

// // //     try {
// // //       const list = await listUsers(params);
// // //       setUsers(list);
// // //     } catch (err) {
// // //       console.log(err);
// // //     }
// // //   };

// // //   const handleDelete = async (userId) => {
// // //     if (!window.confirm(t("Are you sure you want to delete this user?"))) return;
// // //     try {
// // //       await deleteUserApi(userId);
// // //       getUsers();
// // //     } catch (error) {
// // //       console.error("Error deleting user:", error);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     getUsers();
// // //   }, [gender, role, search]);

// // //   const [snackbar, setSnackbar] = useState({
// // //     open: false,
// // //     message: "",
// // //     severity: "success",
// // //   });

// // //   const handleSend = async (email) => {
// // //     try {
// // //       await axiosClient.post("auth/forgot_password/", { email });
// // //       setSnackbar({
// // //         open: true,
// // //         message: t("Password reset email sent successfully!"),
// // //         severity: "success",
// // //       });
// // //     } catch (error) {
// // //       setSnackbar({
// // //         open: true,
// // //         message: t("Failed to send password reset email."),
// // //         severity: "error",
// // //       });
// // //     }
// // //   };

// // //   const handleCloseSnackbar = () => setSnackbar({ open: false, message: "", severity: "success" });

// // //   return (
// // //     <>
// // //       <Snackbar
// // //         open={snackbar.open}
// // //         autoHideDuration={4000}
// // //         onClose={handleCloseSnackbar}
// // //         anchorOrigin={{ vertical: "top", horizontal: "right" }}
// // //       >
// // //         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
// // //           {snackbar.message}
// // //         </Alert>
// // //       </Snackbar>

// // //       <Box display="flex" justifyContent="center" alignItems="center" marginTop="16">
// // //         <Card elevation={16} sx={{ width: "95%" }}>
// // //           <CardContent>
// // //             {/* Filters Section */}
// // //             <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
// // //               <Box sx={{ width: "100%" }}>
// // //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // //                   {t("Search By")}
// // //                 </Typography>
// // //                 <TextField fullWidth label={t("Search")} variant="outlined" value={search} onChange={(e) => setSearch(e.target.value)} />
// // //               </Box>

// // //               <Box sx={{ width: "100%" }}>
// // //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // //                   {t("Filter By")}
// // //                 </Typography>

// // //                 <Box sx={{ display: "flex", gap: 2 }}>
// // //                   <FormControl fullWidth>
// // //                     <InputLabel>{t("Role")}</InputLabel>
// // //                     <Select value={role} label={t("Role")} onChange={(e) => setRole(e.target.value)} sx={{ textAlign: "left" }}>
// // //                       <MenuItem value="">{t("Default")}</MenuItem>
// // //                       {roleChoices.map((r, idx) => (
// // //                         <MenuItem key={idx} value={r.value}>
// // //                           {r.value === "ADMIN" ? t("Admin") : t("Technician")}
// // //                         </MenuItem>
// // //                       ))}
// // //                     </Select>
// // //                   </FormControl>

// // //                   <FormControl fullWidth>
// // //                     <InputLabel>{t("Gender")}</InputLabel>
// // //                     <Select value={gender} label={t("Gender")} onChange={(e) => setGender(e.target.value)} sx={{ textAlign: "left" }}>
// // //                       <MenuItem value="">{t("Default")}</MenuItem>
// // //                       {genderChoices.map((g, idx) => (
// // //                         <MenuItem key={idx} value={g.value}>
// // //                           {t(g.label)}
// // //                         </MenuItem>
// // //                       ))}
// // //                     </Select>
// // //                   </FormControl>
// // //                 </Box>
// // //               </Box>
// // //             </Box>

// // //             {/* Table Section */}
// // //             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // //               <Table stickyHeader>
// // //                 <TableHead>
// // //                   <TableRow>
// // //                     {[
// // //                       "Name",
// // //                       "Surname",
// // //                       "ID Card",
// // //                       "Date of Birth",
// // //                       "Gender",
// // //                       "Email",
// // //                       "Phone Number",
// // //                       "City",
// // //                       "Role",
// // //                       "GDPR Accepted",
// // //                       "Hardcopy Consent",
// // //                       "User ID",
// // //                       "Action",
// // //                       "Forgot Password",
// // //                       "Comment",
// // //                     ].map((h) => (
// // //                       <TableCell key={h} sx={h === "Action" ? { textAlign: "center" } : {}}>
// // //                         <Typography variant="body2" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
// // //                           {t(h)}
// // //                         </Typography>
// // //                       </TableCell>
// // //                     ))}
// // //                   </TableRow>
// // //                 </TableHead>

// // //                 <TableBody>
// // //                   {users.map((row) => (
// // //                     <TableRow key={row.id}>
// // //                       <TableCell>{row.first_name}</TableCell>
// // //                       <TableCell>{row.last_name}</TableCell>
// // //                       <TableCell>{row.id_card || "-"}</TableCell>
// // //                       <TableCell>{row.date_birth || ""}</TableCell>
// // //                       <TableCell sx={{ whiteSpace: "nowrap" }}>
// // //                         {row.gender === "M" ? t("Male") : row.gender === "F" ? t("Female") : t("Non-declared")}
// // //                       </TableCell>
// // //                       <TableCell>{row.email}</TableCell>
// // //                       <TableCell>{row.phone_number}</TableCell>
// // //                       <TableCell>{row.city || "-"}</TableCell>
// // //                       <TableCell>
// // //                         {row.user_role === "ADMIN" ? t("Admin") : t("Technician")}
// // //                       </TableCell>
// // //                       <TableCell>{row.gdpr_accepted ? t("Yes") : t("No")}</TableCell>
// // //                       <TableCell>{row.hardcopy_consent ? t("Yes") : t("No")}</TableCell>
// // //                       <TableCell>{row.id}</TableCell>

// // //                       <TableCell sx={{ textAlign: "center" }}>
// // //                         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
// // //                           <BorderColorOutlinedIcon
// // //                             onClick={() => handleModalOpen(row.id)}
// // //                             sx={{ cursor: "pointer", color: theme.palette.mode === "dark" ? "orange" : "blue" }}
// // //                           />
// // //                           <DeleteOutlineOutlinedIcon onClick={() => handleDelete(row.id)} sx={{ cursor: "pointer", color: "red" }} />
// // //                         </Box>
// // //                       </TableCell>

// // //                       <TableCell>
// // //                         <Button
// // //                           variant="contained"
// // //                           size="small"
// // //                           onClick={() => handleSend(row.email)}
// // //                         >
// // //                           {t("Send")}
// // //                         </Button>
// // //                       </TableCell>

// // //                       <TableCell>
// // //                         <AddComment
// // //                           sx={{ cursor: "pointer", color: theme.palette.mode === "dark" ? "orange" : "blue" }}
// // //                           onClick={() => handleClientModalOpen(row.id)}
// // //                         />
// // //                       </TableCell>
// // //                     </TableRow>
// // //                   ))}
// // //                 </TableBody>
// // //               </Table>
// // //             </TableContainer>
// // //           </CardContent>
// // //         </Card>
// // //       </Box>

// // //       <UserEditModal open={openModal} handleClose={handleModalClose} id={id} getUsers={getUsers} />
// // //       <ClientComment open={openClientModal} handleClose={handleClientModalClose} id={id} getUsers={getUsers} />
// // //     </>
// // //   );
// // // };

// // // export default EditDeleteUsers;

// // import { useState, useEffect } from "react";
// // import {
// //   TableContainer,
// //   Table,
// //   TableHead,
// //   TableRow,
// //   TableCell,
// //   TableBody,
// //   Paper,
// //   Card,
// //   CardContent,
// //   Box,
// //   Typography,
// //   Button,
// //   Alert,
// //   Snackbar,
// // } from "@mui/material";

// // import InputLabel from "@mui/material/InputLabel";
// // import MenuItem from "@mui/material/MenuItem";
// // import FormControl from "@mui/material/FormControl";
// // import Select from "@mui/material/Select";
// // import TextField from "@mui/material/TextField";
// // import { useStateContext } from "../context/ContextProvider";

// // import axiosClient from "../axiosClient";
// // import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// // import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// // import UserEditModal from "../components/UserEditModal";
// // import ClientComment from "../components/ClientComment";

// // import { AddComment } from "@mui/icons-material";
// // import { useTheme } from "@mui/material/styles";
// // import { useTranslation } from "react-i18next";

// // const genderChoices = [
// //   { label: "Male", value: "M" },
// //   { label: "Female", value: "F" },
// // ];

// // const roleChoices = [
// //   { label: "Admin", value: "ADMIN" },
// //   { label: "Technician", value: "TECHNICIAN" },
// // ];

// // const normalizeUsers = (data) => {
// //   if (Array.isArray(data)) return data;
// //   if (data?.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
// //   if (data?.results && Array.isArray(data.results)) return data.results;
// //   return [];
// // };

// // const listUsers = async (params) => {
// //   try {
// //     // ✅ Updated path to /auth/users/ based on your verified URLConf
// //     const res = await axiosClient.get("auth/users/", { params });
// //     return normalizeUsers(res.data);
// //   } catch (err) {
// //     // Fallback if the path differs on specific server environments
// //     const res2 = await axiosClient.get("api/users/", { params });
// //     return normalizeUsers(res2.data);
// //   }
// // };

// // const deleteUserApi = async (userId) => {
// //   // ✅ Standardizing to the auth path
// //   return await axiosClient.delete(`auth/users/${userId}/`);
// // };

// // const EditDeleteUsers = () => {
// //   const theme = useTheme();
// //   const { t } = useTranslation();
// //   const [users, setUsers] = useState([]);
// //   const [openModal, setOpenModal] = useState(false);
// //   const [openClientModal, setOpenClientModal] = useState(false);
// //   const { user } = useStateContext();
// //   const [id, setId] = useState();

// //   const [gender, setGender] = useState("");
// //   const [role, setRole] = useState("");
// //   const [search, setSearch] = useState("");

// //   const handleModalOpen = (id) => {
// //     setId(id);
// //     setOpenModal(true);
// //   };
// //   const handleModalClose = () => setOpenModal(false);

// //   const handleClientModalOpen = (id) => {
// //     setId(id);
// //     setOpenClientModal(true);
// //   };
// //   const handleClientModalClose = () => setOpenClientModal(false);

// //   const getUsers = async () => {
// //     const params = {};
// //     if (role) params.user_role = role; // Match backend field name
// //     if (gender) params.gender = gender;
// //     if (search) params.search = search;

// //     try {
// //       const list = await listUsers(params);
// //       setUsers(list);
// //     } catch (err) {
// //       console.error("Fetch Users Error:", err);
// //     }
// //   };

// //   const handleDelete = async (userId) => {
// //     if (!window.confirm(t("Are you sure you want to delete this user?"))) return;
// //     try {
// //       await deleteUserApi(userId);
// //       getUsers();
// //     } catch (error) {
// //       console.error("Error deleting user:", error);
// //     }
// //   };

// //   useEffect(() => {
// //     getUsers();
// //   }, [gender, role, search]);

// //   const [snackbar, setSnackbar] = useState({
// //     open: false,
// //     message: "",
// //     severity: "success",
// //   });

// //   const handleSend = async (email) => {
// //     try {
// //       await axiosClient.post("auth/forgot_password/", { email });
// //       setSnackbar({
// //         open: true,
// //         message: t("Password reset email sent successfully!"),
// //         severity: "success",
// //       });
// //     } catch (error) {
// //       setSnackbar({
// //         open: true,
// //         message: t("Failed to send password reset email."),
// //         severity: "error",
// //       });
// //     }
// //   };

// //   const handleCloseSnackbar = () => setSnackbar({ open: false, message: "", severity: "success" });

// //   return (
// //     <>
// //       <Snackbar
// //         open={snackbar.open}
// //         autoHideDuration={4000}
// //         onClose={handleCloseSnackbar}
// //         anchorOrigin={{ vertical: "top", horizontal: "right" }}
// //       >
// //         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
// //           {snackbar.message}
// //         </Alert>
// //       </Snackbar>

// //       <Box display="flex" justifyContent="center" alignItems="center" marginTop="16">
// //         <Card elevation={16} sx={{ width: "95%" }}>
// //           <CardContent>
// //             {/* Filters Section */}
// //             <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
// //               <Box sx={{ width: "100%" }}>
// //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// //                   {t("Search By Name/Email")}
// //                 </Typography>
// //                 <TextField fullWidth label={t("Search")} variant="outlined" value={search} onChange={(e) => setSearch(e.target.value)} />
// //               </Box>

// //               <Box sx={{ width: "100%" }}>
// //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// //                   {t("Filter By")}
// //                 </Typography>

// //                 <Box sx={{ display: "flex", gap: 2 }}>
// //                   <FormControl fullWidth>
// //                     <InputLabel>{t("Role")}</InputLabel>
// //                     <Select value={role} label={t("Role")} onChange={(e) => setRole(e.target.value)} sx={{ textAlign: "left" }}>
// //                       <MenuItem value="">{t("All Roles")}</MenuItem>
// //                       {roleChoices.map((r, idx) => (
// //                         <MenuItem key={idx} value={r.value}>
// //                           {r.value === "ADMIN" ? t("Admin") : t("Technician")}
// //                         </MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>

// //                   <FormControl fullWidth>
// //                     <InputLabel>{t("Gender")}</InputLabel>
// //                     <Select value={gender} label={t("Gender")} onChange={(e) => setGender(e.target.value)} sx={{ textAlign: "left" }}>
// //                       <MenuItem value="">{t("All")}</MenuItem>
// //                       {genderChoices.map((g, idx) => (
// //                         <MenuItem key={idx} value={g.value}>
// //                           {t(g.label)}
// //                         </MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>
// //                 </Box>
// //               </Box>
// //             </Box>

// //             {/* Table Section */}
// //             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// //               <Table stickyHeader>
// //                 <TableHead>
// //                   <TableRow>
// //                     {[
// //                       "Name", "Surname", "ID Card", "Date of Birth", "Gender", 
// //                       "Email", "Phone Number", "City", "Role", "GDPR", 
// //                       "Consent", "User ID", "Action", "Password", "Comment"
// //                     ].map((h) => (
// //                       <TableCell key={h}>
// //                         <Typography variant="body2" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
// //                           {t(h)}
// //                         </Typography>
// //                       </TableCell>
// //                     ))}
// //                   </TableRow>
// //                 </TableHead>

// //                 <TableBody>
// //                   {users.map((row) => (
// //                     <TableRow key={row.id} hover>
// //                       <TableCell>{row.first_name}</TableCell>
// //                       <TableCell>{row.last_name}</TableCell>
// //                       <TableCell>{row.id_card || "-"}</TableCell>
// //                       <TableCell>{row.date_birth || "-"}</TableCell>
// //                       <TableCell>{row.gender === "M" ? t("Male") : row.gender === "F" ? t("Female") : t("N/A")}</TableCell>
// //                       <TableCell>{row.email}</TableCell>
// //                       <TableCell>{row.phone_number}</TableCell>
// //                       <TableCell>{row.city || "-"}</TableCell>
// //                       <TableCell>
// //                         <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
// //                           {row.user_role === "ADMIN" ? t("Admin") : t("Technician")}
// //                         </Typography>
// //                       </TableCell>
// //                       <TableCell>{row.gdpr_accepted ? "✅" : "❌"}</TableCell>
// //                       <TableCell>{row.hardcopy_consent ? "✅" : "❌"}</TableCell>
// //                       <TableCell>{row.id}</TableCell>

// //                       <TableCell>
// //                         <Box sx={{ display: "flex", gap: 1 }}>
// //                           <BorderColorOutlinedIcon
// //                             onClick={() => handleModalOpen(row.id)}
// //                             sx={{ cursor: "pointer", color: "blue" }}
// //                           />
// //                           <DeleteOutlineOutlinedIcon onClick={() => handleDelete(row.id)} sx={{ cursor: "pointer", color: "red" }} />
// //                         </Box>
// //                       </TableCell>

// //                       <TableCell>
// //                         <Button variant="outlined" size="small" onClick={() => handleSend(row.email)}>
// //                           {t("Reset")}
// //                         </Button>
// //                       </TableCell>

// //                       <TableCell>
// //                         <AddComment
// //                           sx={{ cursor: "pointer", color: "green" }}
// //                           onClick={() => handleClientModalOpen(row.id)}
// //                         />
// //                       </TableCell>
// //                     </TableRow>
// //                   ))}
// //                 </TableBody>
// //               </Table>
// //             </TableContainer>
// //           </CardContent>
// //         </Card>
// //       </Box>

// //       <UserEditModal open={openModal} handleClose={handleModalClose} id={id} getUsers={getUsers} />
// //       <ClientComment open={openClientModal} handleClose={handleClientModalClose} id={id} getUsers={getUsers} />
// //     </>
// //   );
// // };

// // export default EditDeleteUsers;


// import { useState, useEffect } from "react";
// import {
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Card,
//   CardContent,
//   Box,
//   Typography,
//   Button,
//   Alert,
//   Snackbar,
// } from "@mui/material";

// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import TextField from "@mui/material/TextField";
// import { useStateContext } from "../context/ContextProvider";

// import axiosClient from "../axiosClient";
// import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import UserEditModal from "../components/UserEditModal";
// import ClientComment from "../components/ClientComment";

// import { AddComment } from "@mui/icons-material";
// import { useTheme } from "@mui/material/styles";
// import { useTranslation } from "react-i18next";

// const genderChoices = [
//   { label: "Male", value: "M" },
//   { label: "Female", value: "F" },
// ];

// // ✅ Updated Role Choices to include Reception and Maid
// const roleChoices = [
//   { label: "Admin", value: "ADMIN" },
//   { label: "Reception", value: "RECEPTION" },
//   { label: "Technician", value: "TECHNICIAN" },
//   { label: "Maid", value: "MAID" },
// ];

// const normalizeUsers = (data) => {
//   if (Array.isArray(data)) return data;
//   if (data?.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
//   if (data?.results && Array.isArray(data.results)) return data.results;
//   return [];
// };

// const listUsers = async (params) => {
//   try {
//     const res = await axiosClient.get("auth/users/", { params });
//     return normalizeUsers(res.data);
//   } catch (err) {
//     const res2 = await axiosClient.get("api/users/", { params });
//     return normalizeUsers(res2.data);
//   }
// };

// const deleteUserApi = async (userId) => {
//   return await axiosClient.delete(`auth/users/${userId}/`);
// };

// const EditDeleteUsers = () => {
//   const theme = useTheme();
//   const { t } = useTranslation();
//   const [users, setUsers] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [openClientModal, setOpenClientModal] = useState(false);
//   const { user } = useStateContext();
//   const [id, setId] = useState();

//   const [gender, setGender] = useState("");
//   const [role, setRole] = useState("");
//   const [search, setSearch] = useState("");

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const handleModalOpen = (id) => {
//     setId(id);
//     setOpenModal(true);
//   };
//   const handleModalClose = () => setOpenModal(false);

//   const handleClientModalOpen = (id) => {
//     setId(id);
//     setOpenClientModal(true);
//   };
//   const handleClientModalClose = () => setOpenClientModal(false);

//   const getUsers = async () => {
//     const params = {};
//     if (role) params.user_role = role; 
//     if (gender) params.gender = gender;
//     if (search) params.search = search;

//     try {
//       const list = await listUsers(params);
//       setUsers(list);
//     } catch (err) {
//       console.error("Fetch Users Error:", err);
//     }
//   };

//   const handleDelete = async (userId) => {
//     if (!window.confirm(t("Are you sure you want to delete this user?"))) return;
//     try {
//       await deleteUserApi(userId);
//       getUsers();
//     } catch (error) {
//       console.error("Error deleting user:", error);
//     }
//   };

//   // ✅ FIXED RESET FUNCTION: Passing the email payload correctly
//   const handleSend = async (email) => {
//     if (!email) {
//       setSnackbar({ open: true, message: t("Email not found"), severity: "error" });
//       return;
//     }
//     try {
//       await axiosClient.post("auth/forgot_password/", { email });
//       setSnackbar({
//         open: true,
//         message: t("Password reset email sent successfully!"),
//         severity: "success",
//       });
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: t("Failed to send password reset email."),
//         severity: "error",
//       });
//     }
//   };

//   useEffect(() => {
//     getUsers();
//   }, [gender, role, search]);

//   const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   // ✅ Helper for Role Display: Prevents "Non Declared"
//   const getRoleLabel = (roleValue) => {
//     const found = roleChoices.find(r => r.value === roleValue);
//     if (found) return t(found.label);
//     if (roleValue === "STAFF") return t("Doctor (Staff)");
//     return t("N/A");
//   };

//   return (
//     <>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
//         <Card elevation={16} sx={{ width: "95%" }}>
//           <CardContent>
//             {/* Filters Section */}
//             <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
//               <Box sx={{ width: "100%" }}>
//                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
//                   {t("Search By Name/Email")}
//                 </Typography>
//                 <TextField fullWidth label={t("Search")} variant="outlined" value={search} onChange={(e) => setSearch(e.target.value)} />
//               </Box>

//               <Box sx={{ width: "100%" }}>
//                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
//                   {t("Filter By")}
//                 </Typography>

//                 <Box sx={{ display: "flex", gap: 2 }}>
//                   <FormControl fullWidth>
//                     <InputLabel>{t("Role")}</InputLabel>
//                     <Select value={role} label={t("Role")} onChange={(e) => setRole(e.target.value)} sx={{ textAlign: "left" }}>
//                       <MenuItem value="">{t("All Roles")}</MenuItem>
//                       {roleChoices.map((r, idx) => (
//                         <MenuItem key={idx} value={r.value}>
//                           {t(r.label)}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>

//                   <FormControl fullWidth>
//                     <InputLabel>{t("Gender")}</InputLabel>
//                     <Select value={gender} label={t("Gender")} onChange={(e) => setGender(e.target.value)} sx={{ textAlign: "left" }}>
//                       <MenuItem value="">{t("All")}</MenuItem>
//                       {genderChoices.map((g, idx) => (
//                         <MenuItem key={idx} value={g.value}>
//                           {t(g.label)}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Box>

//             {/* Table Section */}
//             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
//               <Table stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     {/* ✅ REMOVED: ID Card, Date of Birth, City */}
//                     {[
//                       "Name", "Surname", "Gender", 
//                       "Email", "Phone Number", "Role", "GDPR", 
//                       "Consent", "User ID", "Action", "Password", "Comment"
//                     ].map((h) => (
//                       <TableCell key={h}>
//                         <Typography variant="body2" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
//                           {t(h)}
//                         </Typography>
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {users.map((row) => (
//                     <TableRow key={row.id} hover>
//                       <TableCell>{row.first_name}</TableCell>
//                       <TableCell>{row.last_name}</TableCell>
//                       <TableCell>{row.gender === "M" ? t("Male") : row.gender === "F" ? t("Female") : t("N/A")}</TableCell>
//                       <TableCell>{row.email}</TableCell>
//                       <TableCell>{row.phone_number}</TableCell>
//                       <TableCell>
//                         <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
//                           {getRoleLabel(row.user_role)}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>{row.gdpr_accepted ? "✅" : "❌"}</TableCell>
//                       <TableCell>{row.hardcopy_consent ? "✅" : "❌"}</TableCell>
//                       <TableCell>{row.id}</TableCell>

//                       <TableCell>
//                         <Box sx={{ display: "flex", gap: 1 }}>
//                           <BorderColorOutlinedIcon
//                             onClick={() => handleModalOpen(row.id)}
//                             sx={{ cursor: "pointer", color: "blue" }}
//                           />
//                           <DeleteOutlineOutlinedIcon 
//                             onClick={() => handleDelete(row.id)} 
//                             sx={{ cursor: "pointer", color: "red" }} 
//                           />
//                         </Box>
//                       </TableCell>

//                       <TableCell>
//                         {/* ✅ Reset Button calls handleSend with the row email */}
//                         <Button variant="outlined" size="small" onClick={() => handleSend(row.email)}>
//                           {t("Reset")}
//                         </Button>
//                       </TableCell>

//                       <TableCell>
//                         <AddComment
//                           sx={{ cursor: "pointer", color: "green" }}
//                           onClick={() => handleClientModalOpen(row.id)}
//                         />
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </CardContent>
//         </Card>
//       </Box>

//       <UserEditModal open={openModal} handleClose={handleModalClose} id={id} getUsers={getUsers} />
//       <ClientComment open={openClientModal} handleClose={handleClientModalClose} id={id} getUsers={getUsers} />
//     </>
//   );
// };

// export default EditDeleteUsers;



// import { useState, useEffect } from "react";
// import {
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Card,
//   CardContent,
//   Box,
//   Typography,
//   Button,
//   Alert,
//   Snackbar,
// } from "@mui/material";

// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import TextField from "@mui/material/TextField";
// import { useStateContext } from "../context/ContextProvider";

// import axiosClient from "../axiosClient";
// import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import UserEditModal from "../components/UserEditModal";
// import ClientComment from "../components/ClientComment";

// import { AddComment } from "@mui/icons-material";
// import { useTheme } from "@mui/material/styles";
// import { useTranslation } from "react-i18next";

// // Constants for Dropdowns
// const genderChoices = [
//   { label: "Male", value: "M" },
//   { label: "Female", value: "F" },
// ];

// // ✅ Updated with Reception and Maid
// const roleChoices = [
//   { label: "Admin", value: "ADMIN" },
//   { label: "Reception", value: "RECEPTION" },
//   { label: "Technician", value: "TECHNICIAN" },
//   { label: "Maid", value: "MAID" },
// ];

// const normalizeUsers = (data) => {
//   if (Array.isArray(data)) return data;
//   if (data?.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
//   if (data?.results && Array.isArray(data.results)) return data.results;
//   return [];
// };

// const EditDeleteUsers = () => {
//   const theme = useTheme();
//   const { t } = useTranslation();
//   const [users, setUsers] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [openClientModal, setOpenClientModal] = useState(false);
//   const [id, setId] = useState();

//   const [gender, setGender] = useState("");
//   const [role, setRole] = useState("");
//   const [search, setSearch] = useState("");

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const handleModalOpen = (id) => {
//     setId(id);
//     setOpenModal(true);
//   };
//   const handleModalClose = () => setOpenModal(false);

//   const handleClientModalOpen = (id) => {
//     setId(id);
//     setOpenClientModal(true);
//   };
//   const handleClientModalClose = () => setOpenClientModal(false);

//   const getUsers = async () => {
//     const params = {
//       ...(role && { user_role: role }),
//       ...(gender && { gender: gender }),
//       ...(search && { search: search }),
//     };

//     try {
//       const res = await axiosClient.get("auth/users/", { params });
//       setUsers(normalizeUsers(res.data));
//     } catch (err) {
//       console.error("Fetch Users Error:", err);
//     }
//   };

//   const handleDelete = async (userId) => {
//     if (!window.confirm(t("Are you sure you want to delete this user?"))) return;
//     try {
//       await axiosClient.delete(`auth/users/${userId}/`);
//       getUsers();
//     } catch (error) {
//       console.error("Error deleting user:", error);
//     }
//   };

//   // ✅ FIXED: Working Reset function
//   const handleSend = async (email) => {
//     if (!email) {
//       setSnackbar({ open: true, message: t("User email is missing."), severity: "error" });
//       return;
//     }
//     try {
//       // Ensuring the payload is an object with an "email" key
//       await axiosClient.post("auth/forgot_password/", { email: email });
//       setSnackbar({
//         open: true,
//         message: t("Password reset email sent successfully!"),
//         severity: "success",
//       });
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: t("Failed to send password reset email."),
//         severity: "error",
//       });
//     }
//   };

//   useEffect(() => {
//     getUsers();
//   }, [gender, role, search]);

//   const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   // ✅ Helper to prevent "Non Declared"
//   const getRoleLabel = (roleValue) => {
//     const found = roleChoices.find(r => r.value === roleValue);
//     return found ? t(found.label) : t("N/A");
//   };

//   return (
//     <>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
//         <Card elevation={16} sx={{ width: "95%" }}>
//           <CardContent>
//             {/* Filters Section */}
//             <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
//               <Box sx={{ width: "100%" }}>
//                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
//                   {t("Search By Name/Email")}
//                 </Typography>
//                 <TextField fullWidth label={t("Search")} variant="outlined" value={search} onChange={(e) => setSearch(e.target.value)} />
//               </Box>

//               <Box sx={{ width: "100%" }}>
//                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
//                   {t("Filter By")}
//                 </Typography>

//                 <Box sx={{ display: "flex", gap: 2 }}>
//                   <FormControl fullWidth>
//                     <InputLabel>{t("Role")}</InputLabel>
//                     <Select value={role} label={t("Role")} onChange={(e) => setRole(e.target.value)} sx={{ textAlign: "left" }}>
//                       <MenuItem value="">{t("All Roles")}</MenuItem>
//                       {roleChoices.map((r, idx) => (
//                         <MenuItem key={idx} value={r.value}>{t(r.label)}</MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>

//                   <FormControl fullWidth>
//                     <InputLabel>{t("Gender")}</InputLabel>
//                     <Select value={gender} label={t("Gender")} onChange={(e) => setGender(e.target.value)} sx={{ textAlign: "left" }}>
//                       <MenuItem value="">{t("All")}</MenuItem>
//                       {genderChoices.map((g, idx) => (
//                         <MenuItem key={idx} value={g.value}>{t(g.label)}</MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Box>

//             {/* Table Section */}
//             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
//               <Table stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     {/* ✅ City, ID Card, DOB REMOVED */}
//                     {[
//                       "Name", "Surname", "Gender", "Email", "Phone Number", 
//                       "Role", "GDPR", "Consent", "User ID", "Action", "Password", "Comment"
//                     ].map((h) => (
//                       <TableCell key={h}>
//                         <Typography variant="body2" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
//                           {t(h)}
//                         </Typography>
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {users.map((row) => (
//                     <TableRow key={row.id} hover>
//                       <TableCell>{row.first_name}</TableCell>
//                       <TableCell>{row.last_name}</TableCell>
//                       <TableCell>{row.gender === "M" ? t("Male") : row.gender === "F" ? t("Female") : t("N/A")}</TableCell>
//                       <TableCell>{row.email}</TableCell>
//                       <TableCell>{row.phone_number}</TableCell>
//                       <TableCell>
//                         <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
//                           {getRoleLabel(row.user_role)}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>{row.gdpr_accepted ? "✅" : "❌"}</TableCell>
//                       <TableCell>{row.hardcopy_consent ? "✅" : "❌"}</TableCell>
//                       <TableCell>{row.id}</TableCell>

//                       <TableCell>
//                         <Box sx={{ display: "flex", gap: 1 }}>
//                           <BorderColorOutlinedIcon
//                             onClick={() => handleModalOpen(row.id)}
//                             sx={{ cursor: "pointer", color: "blue" }}
//                           />
//                           <DeleteOutlineOutlinedIcon 
//                             onClick={() => handleDelete(row.id)} 
//                             sx={{ cursor: "pointer", color: "red" }} 
//                           />
//                         </Box>
//                       </TableCell>

//                       <TableCell>
//                         <Button variant="outlined" size="small" onClick={() => handleSend(row.email)}>
//                           {t("Reset")}
//                         </Button>
//                       </TableCell>

//                       <TableCell>
//                         <AddComment
//                           sx={{ cursor: "pointer", color: "green" }}
//                           onClick={() => handleClientModalOpen(row.id)}
//                         />
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </CardContent>
//         </Card>
//       </Box>

//       <UserEditModal open={openModal} handleClose={handleModalClose} id={id} getUsers={getUsers} />
//       <ClientComment open={openClientModal} handleClose={handleClientModalClose} id={id} getUsers={getUsers} />
//     </>
//   );
// };

// export default EditDeleteUsers;

/////////////////////////////////////////////////////////////

// import { useState, useEffect } from "react";
// import {
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Card,
//   CardContent,
//   Box,
//   Typography,
//   Button,
//   Alert,
//   Snackbar,
// } from "@mui/material";

// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import TextField from "@mui/material/TextField";
// import { useStateContext } from "../context/ContextProvider";

// import axiosClient from "../axiosClient";
// import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import UserEditModal from "../components/UserEditModal";
// import ClientComment from "../components/ClientComment";

// import { AddComment } from "@mui/icons-material";
// import { useTheme } from "@mui/material/styles";
// import { useTranslation } from "react-i18next";

// // Constants for Dropdowns
// const genderChoices = [
//   { label: "Male", value: "M" },
//   { label: "Female", value: "F" },
// ];

// // ✅ Updated with Reception and Maid to match backend USER_ROLE_CHOICES
// const roleChoices = [
//   { label: "Admin", value: "ADMIN" },
//   { label: "Reception", value: "RECEPTION" },
//   { label: "Technician", value: "TECHNICIAN" },
//   { label: "Maid", value: "MAID" },
// ];

// const normalizeUsers = (data) => {
//   if (Array.isArray(data)) return data;
//   if (data?.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
//   if (data?.results && Array.isArray(data.results)) return data.results;
//   return [];
// };

// const EditDeleteUsers = () => {
//   const theme = useTheme();
//   const { t } = useTranslation();
//   const [users, setUsers] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [openClientModal, setOpenClientModal] = useState(false);
//   const [id, setId] = useState();

//   const [gender, setGender] = useState("");
//   const [role, setRole] = useState("");
//   const [search, setSearch] = useState("");

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const handleModalOpen = (id) => {
//     setId(id);
//     setOpenModal(true);
//   };
//   const handleModalClose = () => setOpenModal(false);

//   const handleClientModalOpen = (id) => {
//     setId(id);
//     setOpenClientModal(true);
//   };
//   const handleClientModalClose = () => setOpenClientModal(false);

//   const getUsers = async () => {
//     const params = {
//       ...(role && { user_role: role }),
//       ...(gender && { gender: gender }),
//       ...(search && { search: search }),
//     };

//     try {
//       // ✅ Using /auth/users/ as verified in your URL configuration
//       const res = await axiosClient.get("auth/users/", { params });
//       setUsers(normalizeUsers(res.data));
//     } catch (err) {
//       console.error("Fetch Users Error:", err);
//     }
//   };

//   const handleDelete = async (userId) => {
//     if (!window.confirm(t("Are you sure you want to delete this user?"))) return;
//     try {
//       // ✅ Pointing to the new UserDetailView endpoint in your backend
//       await axiosClient.delete(`auth/users/${userId}/`);
//       setSnackbar({ open: true, message: t("User deleted successfully"), severity: "success" });
//       getUsers();
//     } catch (error) {
//       console.error("Error deleting user:", error);
//       setSnackbar({ open: true, message: t("Failed to delete user."), severity: "error" });
//     }
//   };

//   const handleSend = async (email) => {
//     if (!email) {
//       setSnackbar({ open: true, message: t("User email is missing."), severity: "error" });
//       return;
//     }
//     try {
//       // ✅ Payload sends the email key to your new forgot_password endpoint
//       await axiosClient.post("auth/forgot_password/", { email: email });
//       setSnackbar({
//         open: true,
//         message: t("Password reset email sent successfully!"),
//         severity: "success",
//       });
//     } catch (error) {
//       console.error("Reset Error:", error);
//       setSnackbar({
//         open: true,
//         message: t("Failed to send password reset email."),
//         severity: "error",
//       });
//     }
//   };

//   useEffect(() => {
//     getUsers();
//   }, [gender, role, search]);

//   const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const getRoleLabel = (roleValue) => {
//     const found = roleChoices.find(r => r.value === roleValue);
//     return found ? t(found.label) : t("N/A");
//   };

//   return (
//     <>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
//         <Card elevation={16} sx={{ width: "95%" }}>
//           <CardContent>
//             <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
//               <Box sx={{ width: "100%" }}>
//                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
//                   {t("Search By Name/Email")}
//                 </Typography>
//                 <TextField fullWidth label={t("Search")} variant="outlined" value={search} onChange={(e) => setSearch(e.target.value)} />
//               </Box>

//               <Box sx={{ width: "100%" }}>
//                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
//                   {t("Filter By")}
//                 </Typography>

//                 <Box sx={{ display: "flex", gap: 2 }}>
//                   <FormControl fullWidth>
//                     <InputLabel>{t("Role")}</InputLabel>
//                     <Select value={role} label={t("Role")} onChange={(e) => setRole(e.target.value)} sx={{ textAlign: "left" }}>
//                       <MenuItem value="">{t("All Roles")}</MenuItem>
//                       {roleChoices.map((r, idx) => (
//                         <MenuItem key={idx} value={r.value}>{t(r.label)}</MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>

//                   <FormControl fullWidth>
//                     <InputLabel>{t("Gender")}</InputLabel>
//                     <Select value={gender} label={t("Gender")} onChange={(e) => setGender(e.target.value)} sx={{ textAlign: "left" }}>
//                       <MenuItem value="">{t("All")}</MenuItem>
//                       {genderChoices.map((g, idx) => (
//                         <MenuItem key={idx} value={g.value}>{t(g.label)}</MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Box>

//             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
//               <Table stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     {/* ✅ ID Card, DOB, City are now removed from the view */}
//                     {[
//                       "Name", "Surname", "Gender", "Email", "Phone Number", 
//                       "Role", "GDPR", "Consent", "User ID", "Action", "Password",
//                       //  "Comment"
//                     ].map((h) => (
//                       <TableCell key={h}>
//                         <Typography variant="body2" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
//                           {t(h)}
//                         </Typography>
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {users.map((row) => (
//                     <TableRow key={row.id} hover>
//                       <TableCell>{row.first_name}</TableCell>
//                       <TableCell>{row.last_name}</TableCell>
//                       <TableCell>{row.gender === "M" ? t("Male") : row.gender === "F" ? t("Female") : t("N/A")}</TableCell>
//                       <TableCell>{row.email}</TableCell>
//                       <TableCell>{row.phone_number}</TableCell>
//                       <TableCell>
//                         <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
//                           {getRoleLabel(row.user_role)}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>{row.gdpr_accepted ? "✅" : "❌"}</TableCell>
//                       <TableCell>{row.hardcopy_consent ? "✅" : "❌"}</TableCell>
//                       <TableCell>{row.id}</TableCell>

//                       <TableCell>
//                         <Box sx={{ display: "flex", gap: 1 }}>
//                           <BorderColorOutlinedIcon
//                             onClick={() => handleModalOpen(row.id)}
//                             sx={{ cursor: "pointer", color: "blue" }}
//                           />
//                           <DeleteOutlineOutlinedIcon 
//                             onClick={() => handleDelete(row.id)} 
//                             sx={{ cursor: "pointer", color: "red" }} 
//                           />
//                         </Box>
//                       </TableCell>

//                       <TableCell>
//                         <Button variant="outlined" size="small" onClick={() => handleSend(row.email)}>
//                           {t("Reset")}
//                         </Button>
//                       </TableCell>

//                       {/* <TableCell>
//                         <AddComment
//                           sx={{ cursor: "pointer", color: "green" }}
//                           onClick={() => handleClientModalOpen(row.id)}
//                         />
//                       </TableCell> */}
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </CardContent>
//         </Card>
//       </Box>

//       <UserEditModal open={openModal} handleClose={handleModalClose} id={id} getUsers={getUsers} />
//       <ClientComment open={openClientModal} handleClose={handleClientModalClose} id={id} getUsers={getUsers} />
//     </>
//   );
// };

// export default EditDeleteUsers;



import { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  Alert,
  Snackbar,
} from "@mui/material";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { useStateContext } from "../context/ContextProvider";

import axiosClient from "../axiosClient";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import UserEditModal from "../components/UserEditModal";
import ClientComment from "../components/ClientComment";

import { AddComment } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

// ✅ Removed genderChoices constant

const roleChoices = [
  { label: "Admin", value: "ADMIN" },
  { label: "Reception", value: "RECEPTION" },
  { label: "Technician", value: "TECHNICIAN" },
  { label: "Maid", value: "MAID" },
];

const normalizeUsers = (data) => {
  if (Array.isArray(data)) return data;
  if (data?.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
  if (data?.results && Array.isArray(data.results)) return data.results;
  return [];
};

const EditDeleteUsers = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openClientModal, setOpenClientModal] = useState(false);
  const [id, setId] = useState();

  // ✅ Removed gender state
  const [role, setRole] = useState("");
  const [search, setSearch] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleModalOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const handleModalClose = () => setOpenModal(false);

  const handleClientModalOpen = (id) => {
    setId(id);
    setOpenClientModal(true);
  };
  const handleClientModalClose = () => setOpenClientModal(false);

  const getUsers = async () => {
    const params = {
      ...(role && { user_role: role }),
      // ✅ Removed gender from API params
      ...(search && { search: search }),
    };

    try {
      const res = await axiosClient.get("auth/users/", { params });
      setUsers(normalizeUsers(res.data));
    } catch (err) {
      console.error("Fetch Users Error:", err);
    }
  };

  const handleDelete = async (userId) => {
    if (!window.confirm(t("Are you sure you want to delete this user?"))) return;
    try {
      await axiosClient.delete(`auth/users/${userId}/`);
      setSnackbar({ open: true, message: t("User deleted successfully"), severity: "success" });
      getUsers();
    } catch (error) {
      console.error("Error deleting user:", error);
      setSnackbar({ open: true, message: t("Failed to delete user."), severity: "error" });
    }
  };

  const handleSend = async (email) => {
    if (!email) {
      setSnackbar({ open: true, message: t("User email is missing."), severity: "error" });
      return;
    }
    try {
      await axiosClient.post("auth/forgot_password/", { email: email });
      setSnackbar({
        open: true,
        message: t("Password reset email sent successfully!"),
        severity: "success",
      });
    } catch (error) {
      console.error("Reset Error:", error);
      setSnackbar({
        open: true,
        message: t("Failed to send password reset email."),
        severity: "error",
      });
    }
  };

  useEffect(() => {
    getUsers();
    // ✅ Removed gender from dependency array
  }, [role, search]);

  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const getRoleLabel = (roleValue) => {
    const found = roleChoices.find(r => r.value === roleValue);
    return found ? t(found.label) : t("N/A");
  };

  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
        <Card elevation={16} sx={{ width: "95%" }}>
          <CardContent>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
              <Box sx={{ width: "100%" }}>
                <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
                  {t("Search By Name/Email")}
                </Typography>
                <TextField fullWidth label={t("Search")} variant="outlined" value={search} onChange={(e) => setSearch(e.target.value)} />
              </Box>

              <Box sx={{ width: "100%" }}>
                <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
                  {t("Filter By")}
                </Typography>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <FormControl fullWidth>
                    <InputLabel>{t("Role")}</InputLabel>
                    <Select value={role} label={t("Role")} onChange={(e) => setRole(e.target.value)} sx={{ textAlign: "left" }}>
                      <MenuItem value="">{t("All Roles")}</MenuItem>
                      {roleChoices.map((r, idx) => (
                        <MenuItem key={idx} value={r.value}>{t(r.label)}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* ✅ Gender FormControl was removed from here */}
                </Box>
              </Box>
            </Box>

            <TableContainer component={Paper} style={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "Name", "Surname", "Email", "Phone Number", 
                      "Role", "GDPR", "Consent", "User ID", "Action", "Password",
                    ].map((h) => (
                      <TableCell key={h}>
                        <Typography variant="body2" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                          {t(h)}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {users.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell>{row.first_name}</TableCell>
                      <TableCell>{row.last_name}</TableCell>
                      {/* ✅ Gender TableCell was removed from here */}
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{row.phone_number}</TableCell>
                      <TableCell>
                        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                          {getRoleLabel(row.user_role)}
                        </Typography>
                      </TableCell>
                      <TableCell>{row.gdpr_accepted ? "✅" : "❌"}</TableCell>
                      <TableCell>{row.hardcopy_consent ? "✅" : "❌"}</TableCell>
                      <TableCell>{row.id}</TableCell>

                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <BorderColorOutlinedIcon
                            onClick={() => handleModalOpen(row.id)}
                            sx={{ cursor: "pointer", color: "blue" }}
                          />
                          <DeleteOutlineOutlinedIcon 
                            onClick={() => handleDelete(row.id)} 
                            sx={{ cursor: "pointer", color: "red" }} 
                          />
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Button variant="outlined" size="small" onClick={() => handleSend(row.email)}>
                          {t("Reset")}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>

      <UserEditModal open={openModal} handleClose={handleModalClose} id={id} getUsers={getUsers} />
      <ClientComment open={openClientModal} handleClose={handleClientModalClose} id={id} getUsers={getUsers} />
    </>
  );
};

export default EditDeleteUsers;